var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaveEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19313",
    "data-name": "Gruppe 19313",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284082",
    "data-name": "Pfad 284082",
    d: "M29.5,22.075a.576.576,0,0,0,.575-.575V16.45A1.552,1.552,0,0,0,28.5,14.925h-12a1.552,1.552,0,0,0-1.575,1.525V31.961a1.535,1.535,0,0,0,1.013,1.425l7,2.588a1.637,1.637,0,0,0,.562.1,1.607,1.607,0,0,0,.92-.287,1.5,1.5,0,0,0,.655-1.238V33.075H28.5A1.577,1.577,0,0,0,30.075,31.5v-4a.575.575,0,0,0-1.15,0v4a.426.426,0,0,1-.425.425H25.075V19.438a1.525,1.525,0,0,0-.929-1.392l-4.524-1.971H28.5a.4.4,0,0,1,.425.375V21.5A.576.576,0,0,0,29.5,22.075ZM23.688,19.1a.376.376,0,0,1,.237.337V34.549a.358.358,0,0,1-.162.294.473.473,0,0,1-.426.053l-7-2.588a.385.385,0,0,1-.261-.347V16.45a.4.4,0,0,1,.425-.375h.243Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284083",
    "data-name": "Pfad 284083",
    d: "M36,24.094l-3.182-3.182a.575.575,0,0,0-.814.813l2.2,2.2H27.5a.575.575,0,0,0,0,1.15h6.7l-2.2,2.2a.575.575,0,1,0,.814.813L36,24.906A.575.575,0,0,0,36,24.094Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19312",
    "data-name": "Gruppe 19312"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24695",
    "data-name": "Rechteck 24695",
    width: 24,
    height: 24,
    transform: "translate(13 13)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveEvent);
export default __webpack_public_path__ + "static/media/leave_event.1444d56a082d2143b45c5da65e91be79.svg";
export { ForwardRef as ReactComponent };